import makeApi from './api';

export default async function fetchCategoryResults(uuid: string, category: string) {
  const api = makeApi();

  const results = [];

  let response;
  let page = 1;

  do {
    response = await api.get(`/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/`, {
      params: { category, page: page++ },
    });

    results.push(...response.data.results);
  } while (response?.data?.paginator?.next);

  return results;
}
